<form [formGroup]="discountForm">
  <div class="modal-content m-0">
    <div class="modal-header">
      @if (c('id').value) {
        <p class="modal-title">
          {{ 'pricing.discount.form.editTitle' | translate }}
        </p>
      } @else {
        <p class="modal-title">
          {{ 'pricing.discount.form.addTitle' | translate }}
        </p>
      }
      <i
        class="fa-light fa-xmark ms-auto cursor-pointer"
        data-cy="close-icon"
        (click)="modalRef.close()"
      ></i>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row">
            <div class="form-group">
              <div class="col-12">
                <div class="row align-items-center mb-1 px-4">
                  <label class="label col-sm-3 form-control-label mb-0">{{
                    'pricing.discount.form.discountType' | translate
                  }}</label>
                  <div class="col-sm-9">
                    <app-select formControlName="discountType">
                      <app-select-option
                        [value]="DiscountType.General"
                        [label]="
                          'pricing.discount.list.discountType.general'
                            | translate
                        "
                      />
                      <app-select-option
                        [value]="DiscountType.Individual"
                        [label]="
                          'pricing.discount.list.discountType.individual'
                            | translate
                        "
                      />
                    </app-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-12">
                <div class="row align-items-center mb-1 px-4">
                  <label class="label col-sm-3 form-control-label mb-0">{{
                    'pricing.discount.form.priceType' | translate
                  }}</label>
                  <div class="col-sm-9">
                    <app-select formControlName="priceType">
                      <app-select-option
                        [value]="DiscountPriceType.WSP"
                        [label]="
                          'pricing.discount.list.priceType.WSP' | translate
                        "
                      />
                      <app-select-option
                        [value]="DiscountPriceType.EUP"
                        [label]="
                          'pricing.discount.list.priceType.EUP' | translate
                        "
                      />
                    </app-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-12">
                <div class="row align-items-center mb-1 px-4">
                  <label class="label col-sm-3 form-control-label mb-0">{{
                    'pricing.discount.form.valueType' | translate
                  }}</label>
                  <div class="col-sm-9">
                    <app-select formControlName="valueType">
                      <app-select-option
                        [value]="ValueType.Percentage"
                        [label]="
                          'pricing.discount.list.valueType.percentage'
                            | translate
                        "
                      />
                      <app-select-option
                        [value]="ValueType.FixedValue"
                        [label]="
                          'pricing.discount.list.valueType.fixed_value'
                            | translate
                        "
                      />
                    </app-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-12">
                <div class="row align-items-center mb-1 px-4">
                  <label class="label col-sm-3 form-control-label mb-0">{{
                    'pricing.discount.form.discountValue' | translate
                  }}</label>
                  <div class="col-sm-9">
                    <input
                      type="number"
                      class="form-control"
                      formControlName="discountValue"
                      [placeholder]="
                        'pricing.discount.form.placeholders.discountValue'
                          | translate
                      "
                    />
                  </div>
                </div>
                <div class="row align-items-center px-4">
                  <div class="col-sm-9 offset-sm-3">
                    <app-validation-error
                      for="discountValue"
                      translations="pricing.discount.form.validation.discountValue"
                    ></app-validation-error>
                  </div>
                </div>
              </div>
            </div>
            @if (c('discountType').value === DiscountType.General) {
              <div class="form-group">
                <div class="col-12">
                  <div class="row align-items-center mb-1 px-4">
                    <label class="label col-sm-3 form-control-label mb-0">{{
                      'pricing.discount.form.validFrom' | translate
                    }}</label>
                    <div class="col-sm-9">
                      <app-date-time
                        [options]="{
                          min: minDate,
                          formControl: discountForm.controls['validFrom'],
                          dateTimeType: DateTimeType.Date,
                        }"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center px-4">
                    <div class="col-sm-9 offset-sm-3">
                      <app-validation-error
                        for="validFrom"
                        translations="pricing.discount.form.validation.validFrom"
                      ></app-validation-error>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12">
                  <div class="row align-items-center mb-1 px-4">
                    <label class="label col-sm-3 form-control-label mb-0">{{
                      'pricing.discount.form.validTo' | translate
                    }}</label>
                    <div class="col-sm-9">
                      <app-date-time
                        [options]="{
                          min: minDate,
                          formControl: discountForm.controls['validTo'],
                          dateTimeType: DateTimeType.Date,
                        }"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center px-4">
                    <div class="col-sm-9 offset-sm-3">
                      <app-validation-error
                        for="validTo"
                        translations="pricing.discount.form.validation.validTo"
                      ></app-validation-error>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="form-group">
              <div class="col-12">
                <div class="row align-items-center px-4">
                  <label class="label col-sm-3 form-control-label mb-0">{{
                    'pricing.discount.form.reason' | translate
                  }}</label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="reason"
                      [placeholder]="
                        'pricing.discount.form.placeholders.reason' | translate
                      "
                    />
                  </div>
                </div>
                <div class="row align-items-center px-4">
                  <div class="col-sm-9 offset-sm-3">
                    <app-validation-error
                      for="reason"
                      translations="validation.generic"
                    ></app-validation-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row">
            <div class="form-group">
              <div class="col-12">
                <div class="row align-items-center px-4">
                  <label class="label col-sm-3 form-control-label mb-0">{{
                    'pricing.discount.form.partner' | translate
                  }}</label>
                  <div class="col-sm-9">
                    <app-partner-typeahead
                      name="partnerIds"
                      id="partnerIds"
                      class="w-50"
                      fieldSize="medium"
                      [clearOnSelect]="true"
                      [placeholder]="
                        c('discountType').value === DiscountType.General
                          ? ('pricing.discount.form.placeholders.partners'
                            | translate)
                          : ('pricing.discount.form.placeholders.partner'
                            | translate)
                      "
                      [disabled]="
                        !!partnerId() ||
                        !!serviceDataReferenceKey() ||
                        !!discountId()
                      "
                      [control]="partnerSearchControl"
                      (partnerSelected)="onPartnerSelect($event)"
                    />
                  </div>
                </div>
                <div class="row align-items-center px-4">
                  <div class="col-sm-9 offset-sm-3">
                    <app-validation-error
                      for="partnerIds"
                      translations="validation.generic"
                    ></app-validation-error>
                  </div>
                </div>
                @if (selectedPartners$ | async; as selectedPartners) {
                  <div class="row align-items-center px-4">
                    <div class="col-12">
                      <div class="bundle-list-container">
                        @for (partner of selectedPartners; track partner.id) {
                          <div
                            class="d-flex justify-content-between align-items-center mb-1 border-bottom"
                          >
                            {{ partner.name }}
                            @if (!discountId()) {
                              <button
                                [ngbTooltip]="
                                  'pricing.discount.form.tooltips.removePartner'
                                    | translate
                                "
                                triggers="hover"
                                class="icon-btn-clear icon-btn-lg"
                                (click)="removePartner(partner.id)"
                              >
                                <i class="fa-light fa-xmark"></i>
                              </button>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            @if (c('discountType').value === DiscountType.General) {
              @if (allPartnerBundles$ | async; as bundles) {
                <div class="form-group">
                  <div class="col-12">
                    <div class="row align-items-center px-4">
                      <label class="label col-sm-3 form-control-label mb-0">{{
                        'pricing.discount.form.bundle' | translate
                      }}</label>
                      <div
                        class="col-12 col-sm-9 d-flex align-items-center justify-content-between gap-2"
                      >
                        <app-configuration-typeahead
                          [placeholder]="
                            !c('partnerIds').value?.length ||
                            !(bundles.length > 0)
                              ? ('pricing.discount.form.placeholders.selectPartnerFirst'
                                | translate)
                              : ('pricing.discount.form.placeholders.bundle'
                                | translate)
                          "
                          [items]="filteredPartnerBundles$ | async"
                          displayPropertyName="internalName"
                          [disabled]="
                            !c('partnerIds').value?.length ||
                            !(bundles.length > 0) ||
                            !!discountId()
                          "
                          (selected)="onBundleSelect($event)"
                        />
                        <button
                          class="icon-btn icon-btn-lg"
                          [ngbTooltip]="
                            'pricing.discount.form.tooltips.addAllPartnerBundles'
                              | translate
                          "
                          triggers="hover"
                          [disabled]="
                            !c('partnerIds').value?.length ||
                            !(bundles.length > 0) ||
                            !!discountId()
                          "
                          (click)="addAllBundles()"
                        >
                          <i class="fa-light fa-cubes"></i>
                        </button>
                      </div>
                    </div>
                    <div class="row align-items-center px-4">
                      <div class="col-sm-9 offset-sm-3">
                        <app-validation-error
                          for="bundleIds"
                          translations="validation.generic"
                        ></app-validation-error>
                      </div>
                    </div>
                    <div class="row align-items-center px-4">
                      <div class="col-12">
                        <div class="bundle-list-container">
                          @if (
                            allPartnerBundles$ | async;
                            as allPartnerBundles
                          ) {
                            @for (
                              bundleId of c('bundleIds').value;
                              track bundleId
                            ) {
                              <div
                                class="d-flex justify-content-between align-items-center mb-1 border-bottom"
                              >
                                {{ bundleId | displayName: allPartnerBundles }}
                                @if (!discountId()) {
                                  <button
                                    [ngbTooltip]="
                                      'pricing.discount.form.tooltips.removeBundle'
                                        | translate
                                    "
                                    triggers="hover"
                                    class="icon-btn-clear icon-btn-lg"
                                    (click)="removeBundle(bundleId)"
                                  >
                                    <i class="fa-light fa-xmark"></i>
                                  </button>
                                }
                              </div>
                            }
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            }
            @if (c('discountType').value === DiscountType.Individual) {
              <div class="form-group">
                <div class="col-12">
                  <div class="row align-items-center px-4">
                    <label class="label col-sm-3 form-control-label mb-0">{{
                      'pricing.discount.form.serviceData' | translate
                    }}</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="serviceDataReferenceKey"
                        [placeholder]="
                          'pricing.discount.form.placeholders.referenceKey'
                            | translate
                        "
                        maxlength="6"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center px-4">
                    <div class="col-sm-9 offset-sm-3">
                      <app-validation-error
                        for="serviceDataReferenceKey"
                        translations="validation.generic"
                      ></app-validation-error>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="submit()">
        {{
          c('id').value
            ? ('common.buttons.btnUpdate' | translate)
            : ('common.buttons.btnCreate' | translate)
        }}
      </button>
    </div>
  </div>
</form>
